export const aftcabinImageOptions = {
  angle: 'aftcabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    Handrail: 1,
    Layout: 1,
    BerthInfill: 1,
    FabricCabins: 1,
    AftCabinShelving: 1,
    SeaBerths: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'BerthInfill',
      dependency: 'FabricCabins'
    },
    {
      option: 'FabricCabins',
      dependency: 'BerthInfill'
    },
    {
      option: 'AftCabinShelving',
      dependency: 'Veneer'
    },
    {
      option: 'SeaBerths',
      dependency: 'FabricCabins'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/aftcabin.js